export default id => `
{
    resourceVisibility {
      showVisibilityMessage(postId: ${id})
    }
  }
`;
